import { useMemo } from 'react';
import { BaseSuggestedRouteProps } from '@lp/features/MultiSuggest';
import { useRouteLocations } from '@lp/features/RoutePlanner/hooks/useRouteLocations';
import { RouteSchema } from '@lp/features/RoutePlanner';
import { AircraftLegResource, BaseLegResourceType, LegLocationTypeEnum } from '@/api/apis/route';
import { CaseResourceType } from '@/api/apis/case';
import { useBaseCaseDetails } from '@/hooks/useBaseCaseDetails';
import { useMultiSuggestionItemByChainQuery } from '@/queries/multi-suggest';
import { DataCacheType } from '@/queries/consts';

export const SuggestedRouteSchema = ({ taskId, chainNumber }: BaseSuggestedRouteProps) => {
  const { caseId, organType } = useBaseCaseDetails();
  const { list } = useRouteLocations(DataCacheType.Snapshot);
  const { data } = useMultiSuggestionItemByChainQuery(taskId, chainNumber, caseId);

  const aircraftsList = useMemo(
    () =>
      data?.resources[CaseResourceType.Aircraft]?.map<BaseLegResourceType<AircraftLegResource>>((a) => ({
        id: a.resourceId,
        type: CaseResourceType.Aircraft,
        data: a.data,
      })) || [],
    [data?.resources],
  );

  const locations = useMemo(() => {
    const mainLocations = list.filter((l) =>
      [LegLocationTypeEnum.hospital, LegLocationTypeEnum.txcenter].includes(l.locationType),
    );

    return [...(data?.locations || []), ...mainLocations];
  }, [data?.locations, list]);

  if (!data) return null;

  return (
    <div className="flex flex-col gap-3 bg-base-90 p-4 rounded-b-lg">
      <span className="text-l-cps text-base-30">SUGGESTED</span>
      <RouteSchema
        organType={organType}
        segments={data.segments}
        legs={data.legs}
        aircrafts={aircraftsList}
        locations={locations}
      />
    </div>
  );
};
